import { CalendarEventResponseStatus } from '@griply/types';

// The semantic slot, not a colour value — each app resolves it against its own
// theme, the same way getCalendarEventGuestStatusLabelKey returns a i18n key.
export enum CalendarEventGuestStatusColor {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Neutral = 'neutral',
}

const STATUS_COLORS: Record<
  CalendarEventResponseStatus,
  CalendarEventGuestStatusColor
> = {
  [CalendarEventResponseStatus.Accepted]: CalendarEventGuestStatusColor.Success,
  [CalendarEventResponseStatus.Declined]: CalendarEventGuestStatusColor.Error,
  [CalendarEventResponseStatus.Tentative]:
    CalendarEventGuestStatusColor.Warning,
  [CalendarEventResponseStatus.NeedsAction]:
    CalendarEventGuestStatusColor.Neutral,
};

// a status this build doesn't know (newer backend), or none recorded at all,
// reads as "no answer yet" — never an undefined colour. The lookup carries the
// falsy cases too: guarding with `status &&` first would return '' unchanged,
// which `??` does not catch and consumers then index their theme map with.
export const getCalendarEventGuestStatusColor = (
  status?: CalendarEventResponseStatus,
): CalendarEventGuestStatusColor =>
  STATUS_COLORS[status as CalendarEventResponseStatus] ??
  CalendarEventGuestStatusColor.Neutral;
